import Dropdown from 'antd/lib/dropdown';
import Menu from 'antd/lib/menu';
import * as React from 'react';
import { runwayColors } from '../styles/globalStyles';
import { AllSortTypes, SortType } from '../../types/sorts';
import { displayTextForSortType } from '../../helpers/displayHelpers';
import { updateFeatureItemsSort } from '../../actions/sorts';
import { useDispatch, useSelector } from 'react-redux';
import { selectSort } from '../../selectors/selectors';
import { RootState } from '../../reducers/reducers';
import { ClockCircleOutlined, SignalFilled, SortAscendingOutlined } from '@ant-design/icons';
import Button from 'antd/lib/button';

interface SortComponentProps {
    onApplySort: (sortType: SortType) => void;
}

const SortComponent: React.FC<SortComponentProps> = (props: SortComponentProps) => {
    const dispatch = useDispatch();

    const onSelectSort = (info) => {
        const sortType = info.key;
        dispatch(updateFeatureItemsSort({ sortType }));

        props.onApplySort(sortType);
    };

    const currentlySelectedSort = useSelector((state: RootState) => selectSort(state));

    const overlayMenu = () => {
        return (
            <Menu onClick={onSelectSort} activeKey={currentlySelectedSort}>
                {AllSortTypes.map((sortType) => (
                    <Menu.Item key={sortType} icon={iconForSortType(sortType)}>
                        {displayTextForSortType(sortType)}
                    </Menu.Item>
                ))}
            </Menu>
        );
    };

    return (
        <Dropdown overlay={overlayMenu} trigger={['click']}>
            <Button icon={iconForSortType(currentlySelectedSort)}>
                Sort: {displayTextForSortType(currentlySelectedSort)}
            </Button>
        </Dropdown>
    );
};

export default SortComponent;

const iconForSortType: (sortType: SortType) => React.ReactNode = (sortType) => {
    const iconStyle: React.CSSProperties = { color: runwayColors.primary };
    switch (sortType) {
        case SortType.CodeAuthor:
        case SortType.TicketOwner:
            return <SortAscendingOutlined style={iconStyle} />;
        case SortType.CodeLastUpdated:
        case SortType.TicketLastUpdated:
            return <ClockCircleOutlined style={iconStyle} />;
        case SortType.CodeStatus:
        case SortType.TicketStatus:
            return <SignalFilled style={iconStyle} />;
        case SortType.LastUpdated:
            return <ClockCircleOutlined style={iconStyle} />;
    }
};
